import { createFileRoute } from "@tanstack/react-router";
import { NanaeHeader, NanaeFooter } from "@/components/qv3/NanaeShared";
import { LegalSection } from "@/components/qorum/LegalSection";
import { socialMeta, pageJsonLd } from "@/lib/seo-meta";

export const Route = createFileRoute("/cgv")({
  head: () => ({
    meta: [
      { title: "Conditions Générales de Vente — Hōjin" },
      {
        name: "description",
        content:
          "Conditions générales de vente de Hōjin : abonnement, à la carte, droit de rétractation, médiation.",
      },
      ...socialMeta({
        title: "Conditions Générales de Vente — Hōjin",
        description: "Conditions générales de vente de Hōjin : abonnement, à la carte, droit de rétractation, médiation.",
        url: "https://hojin.ai/cgv",
        image: "conseil",
        card: "summary",
      }),
    ],
    links: [{ rel: "canonical", href: "https://hojin.ai/cgv" }],
    scripts: pageJsonLd({
      path: "/cgv",
      name: "Conditions Générales de Vente — Hōjin",
      description: "Conditions générales de vente de Hōjin : abonnement, à la carte, droit de rétractation, médiation.",
      type: "WebPage",
      image: "conseil",
      breadcrumb: [{ name: "CGV", path: "/cgv" }],
    }),
  }),
  component: CgvPage,
});

const CGV = [
  {
    title: "Article 1 — Identité du vendeur",
    body: (
      <p>
        UDITEK SAS, société par actions simplifiée au capital de [CAPITAL] €,
        immatriculée au RCS sous le numéro [SIREN], dont le siège social est
        situé [ADRESSE]. Contact : [EMAIL].
      </p>
    ),
  },
  {
    title: "Article 2 — Objet et description du service",
    body: (
      <p>
        Hōjin est un service de délibération assisté par intelligence
        multi-modèles. Le Conseil délibère sur les saisines présentées par le
        Président et lui remet un verdict consultatif accompagné, le cas
        échéant, d'un procès-verbal et d'annexes (livrables).
      </p>
    ),
  },
  {
    title: "Article 3 — Prix",
    body: (
      <>
        <p>
          Abonnement : <strong>29 € TTC par mois</strong>, 30 débats inclus.
        </p>
        <p>
          À la carte : <strong>1,99 € TTC par débat</strong>.
        </p>
        <p>
          Les prix sont indiqués toutes taxes comprises (TVA française
          applicable).
        </p>
      </>
    ),
  },
  {
    title: "Article 4 — Paiement et reconduction",
    body: (
      <>
        <p>
          Les paiements sont opérés via le prestataire Stripe. L'abonnement est
          reconduit automatiquement à chaque échéance mensuelle, jusqu'à
          résiliation.
        </p>
        <p>
          La résiliation peut être effectuée à tout moment depuis l'espace
          compte ; elle prend effet à la fin de la période en cours.
        </p>
      </>
    ),
  },
  {
    title: "Article 5 — Droit de rétractation",
    body: (
      <>
        <p>
          Conformément à l'article L.221-18 du Code de la consommation, le
          Président dispose d'un délai de quatorze (14) jours pour exercer son
          droit de rétractation sur les services numériques.
        </p>
        <p>
          [À valider juriste] En souscrivant à l'abonnement ou à un débat à la
          carte et en demandant l'exécution immédiate du service, le Président
          renonce expressément à son droit de rétractation pour les prestations
          exécutées avant la fin du délai.
        </p>
      </>
    ),
  },
  {
    title: "Article 6 — Réclamations et médiation",
    body: (
      <>
        <p>
          Toute réclamation peut être adressée à [EMAIL]. En cas de litige
          persistant après réclamation écrite, le consommateur peut recourir
          gratuitement au médiateur de la consommation suivant :
        </p>
        <p>
          [MÉDIATEUR — nom, adresse, URL]. Le consommateur reste libre de saisir
          la juridiction compétente.
        </p>
      </>
    ),
  },
  {
    title: "Article 7 — Droit applicable",
    body: (
      <p>
        Les présentes conditions sont soumises au droit français. Tout litige
        relèvera, sauf disposition impérative contraire, des juridictions
        françaises compétentes.
      </p>
    ),
  },
];

export function CgvPage() {
  return (
    <div className="nanae-page" style={{ background: "var(--ivory)", minHeight: "100vh" }}>
      <NanaeHeader title="Conditions Générales de Vente" variant="public" />
      <section
        aria-label="Conditions Générales de Vente"
        style={{ maxWidth: 720, margin: "0 auto", padding: "64px 32px 80px" }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 20,
          }}
        >
          <span
            aria-hidden
            style={{ width: 24, height: 0.5, background: "var(--accent-cramoisi)", display: "inline-block" }}
          />
          <span
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              color: "var(--gold-deep)",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            CGV · Volume MMXXVI
          </span>
        </div>
        <h1
          style={{
            fontFamily: '"Anton", sans-serif',
            fontWeight: 400,
            fontSize: 64,
            color: "var(--charcoal)",
            letterSpacing: "-1.5px",
            textTransform: "uppercase",
            lineHeight: 0.95,
            margin: "0 0 32px",
          }}
        >
          CGV
        </h1>
        <LegalSection articles={CGV} />
      </section>
      <NanaeFooter variant="full" />
    </div>
  );
}
